import { render, staticRenderFns } from "./ActivationBriefAgreementsProvider.vue?vue&type=template&id=336712a5&scoped=true&"
import script from "./ActivationBriefAgreementsProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAgreementsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336712a5",
  null
  
)

export default component.exports